<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <title-text />
          <content-text />
        </b-card>
        <content-items v-if="itemData.id" />
        <seo-card />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <page-settings />
        <image-card />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import { required } from '@validations'

import TitleText from '@/views/Admin/Contents/elements/TitleText.vue'
import ContentText from '@/views/Admin/Contents/elements/ContentText.vue'
import PageSettings from '@/views/Admin/Contents/elements/PageSettings.vue'
import ImageCard from '@/views/Admin/Contents/elements/ImageCard.vue'
import SeoCard from '@/views/Admin/Contents/elements/SeoCard.vue'
import ContentItems from '@/views/Admin/Contents/elements/ContentItems.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    ContentText,
    PageSettings,
    ImageCard,
    SeoCard,
    ContentItems,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
}
</script>
